import {Component, Input, OnInit} from '@angular/core';
import {AppService} from '@shared/services/app.service';

@Component({
    selector: 'app-copy-to-clip-board',
    template: `
        <i class="pi pi-copy cursor-pointer text-primary"
           pTooltip="Copy to clipboard"
           (click)="copyToClipboard()">
        </i>
    `,
    styles: []
})
export class CopyToClipBoardComponent implements OnInit {
    @Input() text: string;

    constructor(private app: AppService) {
    }

    ngOnInit(): void {
    }

    copyToClipboard() {
        this.app.copyToClipboard(this.text);
    }
}
